import React, { useEffect, useState } from "react";
import "@fontsource/merienda";
import "@fontsource/merienda/700.css";
import "@fontsource/merienda/900.css";
import "@fontsource/manrope";
import "@fontsource/manrope/600.css";
import LandingHeader from "../components/LandingHeader";
import solution1 from "../assets/images/svgs/sol1.svg";
import solution2 from "../assets/images/svgs/sol2.svg";
import solution3 from "../assets/images/svgs/sol3.svg";
import solution4 from "../assets/images/svgs/sol4.svg";
import "../assets/css/LandingPage.css";
import { ArrowUp } from "lucide-react";
import Footer from "../components/Footer";
import heroImage from "../assets/images/pngs/home.png";
import TestimonialCarousel from "../components/TestimonialCarousel";
import Faqs from "../components/Faqs";
import Form from "../components/Form";
import Preloader from "../components/Preloader";
import vectorImg from "../assets/images/pngs/8835293.jpg";
import AddService from "../assets/images/pngs/234.png";
import ManageOrder from "../assets/images/pngs/65465.png";
import shareLink from "../assets/images/pngs/2543.png";
import Incorrect from "../assets/images/svgs/incorrect.svg";
import correct from "../assets/images/svgs/correct.svg";
import Features from "../components/Features";
import PrimaryBtn from "../components/Button/PrimaryBtn";

const Landingpage = () => {
  const [loading, setLoading] = useState(true);
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500); // same duration as loader

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Preloader />;
  }
  return (
    <div className="landing-page-font">
      <LandingHeader />

      {/* Hero Section */}
      <section
        id="home"
        className="
    px-6 relative
    bg-gradient-to-br from-orange-50 via-white to-orange-100
    lg:bg-[#FFF4F1]
    lg:bg-none
    lg:rounded-bl-[50%]
    pt-[80px] sm:pt-[100px]  /* avoid overlap with header */
    min-h-[calc(100dvh-80px)] sm:min-h-[calc(100dvh-100px)] /* avoid cutting content */
  "
      >
        {/* Hero section */}
        <div className="max-w-7xl min-h-[100dvh] mx-auto flex flex-col md:flex-row items-center gap-10 md:gap-2 justify-between">
          {/* Left Content */}
          <div className="flex-1 text-center md:text-left">
            <h1 className="text-3xl sm:text-4xl md:text-xl xl:text-6xl font-extrabold leading-2 mb-6   tracking-wide">
              Run Your <span className="text-orange">Tiffin Business</span>{" "}
              Professionally
            </h1>

            <p className="font-body font-semibold text-gray-600 text-base sm:text-md mb-8 max-w-sm mx-auto md:mx-0">
              Manage orders, subscriptions, customers, and payments — all in one
              simple app built only for tiffin makers.
            </p>

            {/* CTA Button */}
            <PrimaryBtn btnName={"Get the App for Free"} />
          </div>

          {/* Right Image */}
          <div className="flex-1 relative flex justify-center items-center pt-10">
            {/* Circle Background */}
            <div
              className="
              block md:hidden lg:block 
    w-80 h-80
    sm:w-80 sm:h-80
    md:w-96 md:h-96
    lg:w-[450px] lg:h-[450px]
    bg-[#ff6943]/20
    rounded-full
    outline outline-1 outline-[#FFDBD2] outline-offset-[20px]
  "
            ></div>

            {/* Responsive Image */}
            <img
              src={heroImage}
              alt="App Preview"
              className="
      absolute
      w-56
      sm:w-56
      md:w-72 
      object-contain
    "
            />
          </div>
        </div>
      </section>

      <section>
        <div className="py-12 px-6 mt-12">
          {/* Title */}
          <div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl text-center leading-2 mb-6    font-extrabold">
              All-In-One Solution For{" "}
              <span className="text-orange">Tiffn Service</span> Management
            </h1>
            <p className="font-body text-gray-600 text-base sm:text-md mb-8 max-w-md mx-auto ">
              Easily manage your customers, orders, and payments.
            </p>
          </div>
          {/* Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 max-w-7xl mx-auto">
            {/* Card 1 */}
            <div className="group bg-white rounded-2xl p-10 shadow-sm hover:shadow-xl transition-all duration-300 border border-[#FFCCBF] hover:-translate-y-2">
              <div className="flex flex-col items-center text-center">
                <div className="    mb-4 ">
                  <img src={solution1} alt="sol1" className="w-12 h-12" />
                </div>

                <h3 className="text-md font-bold font-body mb-2">
                  Customer Management
                </h3>

                <p className="text-xs text-[#191919]/80 font-body leading-relaxed">
                  Store and manage all your customer details in one secure
                  place.
                </p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="group bg-white rounded-2xl p-10 shadow-sm hover:shadow-xl transition-all duration-300 border border-[#FFCCBF] hover:-translate-y-2">
              <div className="flex flex-col items-center text-center">
                <div className="    mb-4 ">
                  <img src={solution2} alt="sol2" className="w-12 h-12" />
                </div>

                <h3 className="text-md font-bold font-body mb-2">
                  Order Management
                </h3>

                <p className="text-xs text-[#191919]/80 font-body leading-relaxed">
                  Track, update and manage all incoming orders effortlessly.
                </p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="group bg-white rounded-2xl p-10 shadow-sm hover:shadow-xl transition-all duration-300 border border-[#FFCCBF] hover:-translate-y-2">
              <div className="flex flex-col items-center text-center">
                <div className="    mb-4 ">
                  <img src={solution3} alt="sol3" className="w-12 h-12" />
                </div>

                <h3 className="text-md font-bold font-body mb-2">
                  Payment Handling
                </h3>

                <p className="text-xs text-[#191919]/80 font-body leading-relaxed">
                  Accept and manage secure payments directly through the app.
                </p>
              </div>
            </div>

            {/* Card 4 */}
            <div className="group bg-white rounded-2xl p-10 shadow-sm hover:shadow-xl transition-all duration-300 border border-[#FFCCBF] hover:-translate-y-2">
              <div className="flex flex-col items-center text-center">
                <div className="    mb-4 ">
                  <img src={solution4} alt="sol4" className="w-12 h-12" />
                </div>

                <h3 className="text-md font-bold font-body mb-2">
                  Analytics & Reports
                </h3>

                <p className="text-xs text-[#191919]/80 font-body leading-relaxed">
                  Gain insights into sales performance and customer behavior.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="feature" className="relative bg-white">
        {/* Sticky Title (offset for header height) */}
        <div className="sticky top-18 z-50 bg-white py-8 ">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-4xl md:text-5xl   font-extrabold  ">
              Features
            </h1>
            <p className="text-gray-600 mt-4 font-body max-w-2xl mx-auto">
              Everything you need to run and scale your tiffin business
              professionally.
            </p>
          </div>
        </div>
        <Features />

        {/* Feature Stack */}
      </section>

      {/* How it works section */}
      <section
        id="how-it-works"
        className="flex justify-center items-center md:min-h-screen "
      >
        <div className="p-8 mt-12 max-w-7xl">
          {/* Title */}
          <div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl text-center  font-extrabold leading-2 mb-6 ">
              How it <span className="text-orange">Works</span>
            </h1>
            <p className="font-body text-gray-600 text-base sm:text-md mb-8 max-w-md mx-auto text-center ">
              Get going in 3 easy steps
            </p>
          </div>
          {/* Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3  gap-8  mx-auto">
            {/* Card 1 */}
            <div
              className="group relative bg-white rounded-3xl p-8 min-h-[380px] 
                shadow-md hover:shadow-2xl 
                transition-all duration-500 
                border border-orange-100 
                hover:-translate-y-3 hover:scale-[1.02]"
            >
              {/* Soft Glow Background */}
              <div
                className="absolute inset-0 rounded-3xl bg-gradient-to-br 
                  from-orange-50 via-white to-white 
                  opacity-0 group-hover:opacity-100 
                  transition duration-500"
              ></div>

              <div className="relative flex flex-col justify-center items-center text-center h-full">
                {/* Illustration Container */}
                <div className="mb-8">
                  <img
                    src={AddService}
                    alt="Step 1"
                    className="w-full object-contain rounded-xl"
                  />
                </div>

                {/* Description */}
                <p className="text-black font-semibold font-body text-base leading-relaxed max-w-xs">
                  Add tiffin service details to create your personal tiffin
                  website
                </p>
              </div>
            </div>

            {/* Card 2 */}
            <div
              className="group relative bg-white rounded-3xl p-8 min-h-[380px] 
                shadow-md hover:shadow-2xl 
                transition-all duration-500 
                border border-orange-100 
                hover:-translate-y-3 hover:scale-[1.02]"
            >
              {/* Soft Glow Background */}
              <div
                className="absolute inset-0 rounded-3xl bg-gradient-to-br 
                  from-orange-50 via-white to-white 
                  opacity-0 group-hover:opacity-100 
                  transition duration-500"
              ></div>

              <div className="relative flex flex-col justify-center items-center text-center h-full">
                {/* Illustration Container */}
                <div className="mb-8">
                  <img
                    src={shareLink}
                    alt="Step 1"
                    className="w-full object-contain rounded-xl"
                  />
                </div>

                {/* Description */}
                <p className="text-black font-semibold font-body text-base leading-relaxed max-w-xs">
                  Share website link with your customers
                </p>
              </div>
            </div>

            {/* Card 3 */}
            <div
              className="group relative bg-white rounded-3xl p-8 min-h-[380px] 
                shadow-md hover:shadow-2xl 
                transition-all duration-500 
                border border-orange-100  
                hover:-translate-y-3 hover:scale-[1.02]"
            >
              {/* Soft Glow Background */}
              <div
                className="absolute inset-0 rounded-3xl bg-gradient-to-br 
                  from-orange-50 via-white to-white 
                  opacity-0 group-hover:opacity-100 
                  transition duration-500"
              ></div>

              <div className="relative flex flex-col justify-center items-center text-center h-full">
                {/* Illustration Container */}
                <div className="mb-8 ">
                  <img
                    src={ManageOrder}
                    alt="Step 1"
                    className="w-full object-contain rounded-xl"
                  />
                </div>

                {/* Description */}
                <p className="text-black font-semibold font-body text-base leading-relaxed max-w-xs">
                  Start managing orders & payments with TiffinTap app
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why tiffin tap */}
      <section
        id="why-tiffintap"
        className="relative bg-gradient-to-br from-orange-50 via-white to-orange-100 bg-[#FFF4F1] lg:bg-none rounded-tr-[50%] rounded-bl-[50%] min-h-screen flex justify-center items-center"
      >
        <div className="max-w-7xl mx-auto px-6">
          {/* Title */}
          <div className="text-center mb-16">
            <h1 className="text-3xl sm:text-4xl md:text-5xl  font-extrabold">
              Why <span className="text-orange-500">TiffinTap</span>
            </h1>
            <p className="text-gray-600 mt-4 max-w-xl font-body mx-auto">
              Stop managing chaos. Start running your tiffin business like a
              pro.
            </p>
          </div>

          {/* Comparison Card */}
          <div className="bg-white rounded-3xl shadow-xl border border-orange-100 p-6 md:p-16">
            <div className="grid md:grid-cols-2 gap-12">
              {/* LEFT SIDE */}
              <div className="pt-8">
                <h3 className="text-2xl font-body font-bold mb-8 text-gray-800">
                  WhatsApp + Notebook
                </h3>

                <ul className="space-y-6 text-gray-700">
                  <li className="flex items-start gap-4">
                    <span className="text-red-500 text-xl">
                      <img
                        src={Incorrect}
                        alt="Incorrect"
                        className="w-5 h-5"
                      />
                    </span>
                    Orders can be missed
                  </li>

                  <li className="flex items-start gap-4">
                    <span className="text-red-500 text-xl">
                      <img
                        src={Incorrect}
                        alt="Incorrect"
                        className="w-5 h-5"
                      />
                    </span>
                    Payment confusion
                  </li>

                  <li className="flex items-start gap-4">
                    <span className="text-red-500 text-xl">
                      <img
                        src={Incorrect}
                        alt="Incorrect"
                        className="w-5 h-5"
                      />
                    </span>
                    Manual follow-up
                  </li>

                  <li className="flex items-start gap-4">
                    <span className="text-red-500 text-xl">
                      <img
                        src={Incorrect}
                        alt="Incorrect"
                        className="w-5 h-5"
                      />
                    </span>
                    No delivery proof
                  </li>

                  <li className="flex items-start gap-4">
                    <span className="text-red-500 text-xl">
                      <img
                        src={Incorrect}
                        alt="Incorrect"
                        className="w-5 h-5"
                      />
                    </span>
                    Hard to scale
                  </li>
                </ul>
              </div>

              {/* RIGHT SIDE */}
              <div className=" bg-orange-50 rounded-2xl p-8 border border-orange-200">
                <h3 className="text-2xl font-body font-bold mb-8 text-gray-800">
                  TiffinTap
                </h3>

                <ul className="space-y-6 text-gray-800">
                  <li className="flex items-start gap-4">
                    <span className="text-green-500 text-xl">
                      <img src={correct} alt="correct" className="w-5 h-5" />
                    </span>
                    All orders recorded
                  </li>

                  <li className="flex items-start gap-4">
                    <span className="text-green-500 text-xl">
                      <img src={correct} alt="correct" className="w-5 h-5" />
                    </span>
                    Clear balance sheet
                  </li>

                  <li className="flex items-start gap-4">
                    <span className="text-green-500 text-xl">
                      <img src={correct} alt="correct" className="w-5 h-5" />
                    </span>
                    Auto subscription orders
                  </li>

                  <li className="flex items-start gap-4">
                    <span className="text-green-500 text-xl">
                      <img src={correct} alt="correct" className="w-5 h-5" />
                    </span>
                    Delivery photo stored
                  </li>

                  <li className="flex items-start gap-4">
                    <span className="text-green-500 text-xl">
                      <img src={correct} alt="correct" className="w-5 h-5" />
                    </span>
                    Built for growth
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section
        className="pt-20 pb-16 px-6 mx-auto max-w-7xl min-h-auto "
        id="testimonial"
      >
        <div className=" ">
          <div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl text-center   leading-2 mb-6  font-extrabold">
              What <span className="text-orange">Our Users</span> Are Saying
            </h1>
            <p className="font-body text-gray-600 text-base sm:text-md mb-8 max-w-md mx-auto text-center ">
              Trusted by tiffin providers to manage, scale, and succeed.
            </p>
          </div>

          <div>
            <TestimonialCarousel />
          </div>
        </div>
      </section>

      <section
        id="faqs"
        className="relative bg-gradient-to-br from-orange-50 via-white to-orange-100 bg-[#FFF4F1] lg:bg-none rounded-tr-[50%] flex justify-center items-center min-h-screen"
      >
        <div className="pt-20 pb-16 px-6 max-w-7xl mx-auto">
          <div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl text-center leading-2 mb-6  font-extrabold">
              Faqs
            </h1>
            <p className="font-body text-gray-600 text-base sm:text-md mb-8 max-w-md mx-auto text-center ">
              Need help? Check out our most frequently asked questions.
            </p>
          </div>
          <div>
            <Faqs />
          </div>
        </div>
      </section>

      <section className="pt-20 pb-16 px-6 ">
        <div className="max-w-7xl mx-auto">
          <div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl text-center md:text-start  leading-2 mb-6  font-extrabold">
              We Hope By Now You’re Clear{" "}
              <span className="text-orange">About Our App</span> And The Idea
              Behind It.
            </h1>
            <p className="font-body text-gray-600 text-base sm:text-md mb-8 max-w-5xl font-bold text-center md:text-start ">
              Tiffintap was built by people who once ran a tiffin service, so we
              know the struggles you face managing orders, payments, and
              customers without losing your peace of mind.
            </p>
          </div>
          <div className="mb-24">
            <h3 className="text-xl sm:text-2xl md:text-2xl text-center md:text-start font-body leading-2 mb-6 font-bold tracking-wide">
              Download The App And Start Managing Your Business For Free Today.
            </h3>
            <p className="font-body text-gray-600 text-base sm:text-md mb-8 max-w-2xl   text-center md:text-start ">
              <strong className="text-orange">No credit card</strong> required.{" "}
              <strong className="text-orange">No commissions</strong>. Just a
              simple tool to help your tiffin business grow.
            </p>
            <div className="mb-8 flex justify-center md:justify-start">
              <PrimaryBtn btnName={"Download App"} />
            </div>
          </div>
        </div>
      </section>

      <section
        id="contact"
        className="relative bg-gradient-to-br from-orange-50 via-white to-orange-100 lg:bg-none lg:bg-[#FFF4F1] overflow-hidden"
      >
        {/* 🌊 TOP WAVY */}
        <div className="absolute top-0 left-0 w-full overflow-hidden hidden lg:block">
          <svg
            viewBox="0 0 1440 320"
            className="w-full h-28 md:h-40"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              d="M0,224L60,202.7C120,181,240,139,360,133.3C480,128,600,160,720,186.7C840,213,960,235,1080,218.7C1200,203,1320,149,1380,122.7L1440,96L1440,0L0,0Z"
            ></path>
          </svg>
        </div>

        {/* CONTENT */}
        <div className="relative z-10 max-w-6xl mx-auto px-6 py-2  lg:py-32 text-center">
          <h3 className="text-xl sm:text-2xl md:text-3xl leading-tight mb-10  font-extrabold">
            If You Still Have Any Questions, Feel Free To Contact Us. We’ll Be
            Happy To Help.
          </h3>

          <div className="text-start">
            <Form />
          </div>
        </div>

        {/* 🌊 BOTTOM WAVY */}
        <div className="absolute bottom-0 left-0 w-full overflow-hidden hidden lg:block">
          <svg
            viewBox="0 0 1440 320"
            className="w-full h-28 md:h-40"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              d="M0,96L60,117.3C120,139,240,181,360,192C480,203,600,181,720,149.3C840,117,960,75,1080,90.7C1200,107,1320,181,1380,218.7L1440,256L1440,320L0,320Z"
            ></path>
          </svg>
        </div>
      </section>

      {showScroll && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-50 bg-orange-500 hover:bg-orange-600 text-white p-4 rounded-full shadow-xl transition-all duration-300 hover:scale-110 active:scale-95"
        >
          <ArrowUp size={22} />
        </button>
      )}

      <Footer />
    </div>
  );
};

export default Landingpage;
